import { Dispatch } from 'redux'

import {
  create,
  destroy,
  skipFetchDataOnUpdate,
  TPatchKpiOptionBody,
  TPostKpiOptionBody,
  update
} from 'redux/api/KpiOptions'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as UserEvents from 'redux/api/internal/UserEvents'
import { Action } from 'types/GlobalUserEvents'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

function tryCreateKpiOption(
  body: TPostKpiOptionBody,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        if (body.slices !== undefined) {
          UserEvents.log({
            action: Action.KPI_OPTION_SLICE_CREATED,
            context: null,
            dashboard_id: null,
            dashboard_group_id: null
          })
        }

        dispatch(actions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.MetricCreated))

        callback?.()
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.MetricCreatedFailed))

        callback?.(true)
      })
  }
}

function tryUpdateKpiOption(
  id: string,
  body: TPatchKpiOptionBody,
  cb?: () => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, body)
      .then((response) => {
        if (body.slices !== undefined) {
          UserEvents.log({
            action: Action.KPI_OPTION_SLICE_EDITED,
            context: null,
            dashboard_id: null,
            dashboard_group_id: null
          })
        }

        dispatch(
          actions.updateSuccess({
            // For some reason API returns a list.
            data: response.data.data[0],
            skipFetchData: skipFetchDataOnUpdate(body)
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.MetricUpdated))

        cb?.()
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.MetricUpdatedFailed))

        cb?.()
      })
  }
}

function tryDeleteKpiOption(id: string, widgetId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(
          actions.destroySuccess({
            id,
            widgetId: widgetId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.MetricDeleted))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.MetricDeletedFailed))
      })
  }
}

export const useKpiOptionActions = () => {
  return {
    tryCreateKpiOption: useThunkActions(tryCreateKpiOption),
    tryUpdateKpiOption: useThunkActions(tryUpdateKpiOption),
    tryDeleteKpiOption: useThunkActions(tryDeleteKpiOption)
  }
}
